const union = require('./union')
const Result = require('./result')
const Maybe = require('./maybe')

module.exports = {
  union,
  Result,
  Maybe
}
